import axios from 'axios'
import {
	ElMessage,
	ElMessageBox,
	Message
} from "element-plus"
import {
	getCurrentInstance,
} from "vue";
import {
	messageNew
} from '@/utils/resetMe'
import {
	getToken,
	removeToken
} from './auth'
import store from "../store";

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	baseURL: process.env.VUE_APP_BASE_API,
	// 超时
	timeout: 200000
})
// request拦截器
service.interceptors.request.use(config => {
	// 是否需要设置 token
	// debugger
	const isToken = (config.headers || {}).isToken === false
	if (getToken() && !isToken) {
		// console.log(getToken())
		config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
	}
	// get请求映射params参数
	if (config.method === 'get' && config.params) {
		let url = config.url + '?';
		for (const propName of Object.keys(config.params)) {
			const value = config.params[propName];
			var part = encodeURIComponent(propName) + "=";
			if (value !== null && typeof (value) !== "undefined") {
				if (typeof value === 'object') {
					for (const key of Object.keys(value)) {
						if (value[key] !== null && typeof (value[key]) !== 'undefined') {
							let params = propName + '[' + key + ']';
							let subPart = encodeURIComponent(params) + '=';
							url += subPart + encodeURIComponent(value[key]) + '&';
						}
					}
				} else {
					url += part + encodeURIComponent(value) + "&";
				}
			}
		}
		url = url.slice(0, -1);
		config.params = {};
		config.url = url;
	}
	return config
}, error => {
	console.log(error)
	Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {

	// 未设置状态码则默认成功状态
	const code = res.data.retCode || 200;
	// 获取错误信息
	// const msg = errorCode[code] || res.data.msg || errorCode['default']
	if (code == 401) {
		store.dispatch('LogOut').then(() => {
			location.href = '/login';
		})
		return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
	} else {
		// 查询类 status = 0  status = -1
		// 操作类 status = 1  status = -1
		// ElMessage.success('操作成功')
		// iiot返回结构体
		// console.log(res, 'res------------获取的数据')
		if (res.data.status) {
			if (res.data.status == '0') {
				return res.data.data;
			}
			if (res.data.status == '1') {
				// messageNew.success(res.data.msg)
				return res.data.data;
			}
			if (res.data.status == '-1') {
				messageNew.error(res.data.msg)
				// return res.data;
				return Promise.reject(res.data.msg)
			}
		} else {
			// 导出功能 后端把文件名放到了响应头里，赋值到data里
			if (res.headers) {
				if (res.headers['content-disposition']) {
					let disposition = res.headers['content-disposition']
					res.data.filename = decodeURI(disposition.split('filename=')[1])
				}
			}
			return res.data
		}
	}
},
	error => {
		// console.log('err' + error)
		let {
			message,
			response
		} = error;
		if (response.status == 401) {
			removeToken();
			store.dispatch("LogOut");
			ElMessage.error('无效的会话或者会话已过期.')
			return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
		}
		if (message == "Network Error") {
			message = "后端接口连接异常";
		} else if (message.includes("timeout")) {
			message = "系统接口请求超时";
		} else if (message.includes("Request failed with status code")) {
			message = "系统接口" + message.substr(message.length - 3) + "异常";
		}
		ElMessage({
			message: message,
			type: 'error',
			duration: 2 * 1000
		})
		return Promise.reject(error)
	}
)

export default service
